<template>

    <div id="layout-content" class="pt-4">

        <div class="container">

            <div v-if="noEnrollments && preScreens.length > 0">

                <h2>{{ $t('courses.header_prescreen') }}</h2>
                <div v-html="$t('courses.content_prescreen')"></div>
                <div v-for="preScreen in preScreens" :key="preScreen.id" class="card p-3 mb-3 course-listing">
                    <h4 class="m-0 float-left">{{ preScreen.display_name }}</h4>
                    <span class="mb-2" v-if="preScreen.description != null">{{preScreen.description}}</span>
                    <button class="btn btn-primary otu-blue-bg border-0 p-2" @click="enrollPreScreen(preScreen.id)">{{ $t('courses.begin')}} {{ preScreen.display_name }} <font-awesome-icon class="ml-1" :icon="['fas', 'arrow-right']" /></button>
                </div>

                <div v-if="preScreens.length == 0">
                    <p>{{ $t('courses.no_prescreens') }}</p>
                </div>

            </div>

            <div v-else-if="activeEnrollments.length > 0">
                <h2>{{ $t('courses.header_active') }}</h2>
                {{ $t('courses.content_active') }}
                <div class="card p-3 mb-3 course-listing" v-for="enrollment in activeEnrollments" :key="enrollment.id">
                    <h4 class="m-0 float-left">{{ enrollment.program.display_name }}
                        <span class="date float-right font-italic text-muted">{{ dateRangeFormat(enrollment.starts_at, enrollment.ends_at) }}</span>
                    </h4>
                    <span class="mb-2" v-if="enrollment.program.description != null">{{enrollment.program.description}}</span>
                    <div class="row" v-if="enrollment.program.state != 'draft'">
                        <div class="col px-2">
                            <router-link :to="{ name: 'therapy.display', params: { enrol_id: enrollment.id } }" tag="button" class="btn btn-primary otu-blue-bg border-0 w-100">
                                <div class="row">
                                    <div @click="displayEnrollmentHandler(enrollment.id)" class="col" v-if="enrollment.first_viewed_at != null">{{ $t('courses.resume')}} {{ enrollment.program.display_name }} 
                                        <font-awesome-icon class="ml-2" :icon="['fas', 'play']" />
                                    </div> 
                                    <div @click="displayEnrollmentHandler(enrollment.id)" class="col" v-else>{{ $t('courses.open')}} {{ enrollment.program.display_name }}
                                        <font-awesome-icon class="ml-2" :icon="['fas', 'play']" />
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-md-3 px-2">
                            <button class="btn btn-danger border-0 w-100" @click="btnWithdraw(enrollment.id)">{{ $t('courses.withdraw')}} <font-awesome-icon class="ml-1" :icon="['fas', 'exclamation-triangle']" /></button>
                        </div>
                    </div>
					<div class="row" v-else>
                        <div class="col px-2">
                            <button tag="button" class="btn btn-secondary otu-blue-bg border-0 w-100" disabled>
								<span>{{ $t('courses.unavailable', { program_name: enrollment.program.display_name }) }}</span>
                                <font-awesome-icon class="ml-2" :icon="['fas', 'stop']" style="color: red" />
                            </button>
                        </div>
					</div>
                </div>
            </div>

            <div v-else>
                <h2>{{ $t('courses.none_available') }}</h2>
            </div>

            <div v-if="futureEnrollments.length > 0">
                <h2>{{ $t('courses.title_upcoming') }}</h2>
                <div class="card p-3 mb-3 course-listing" v-for="enrollment in futureEnrollments" :key="enrollment.id">
                    <h4 class="m-0 float-left">{{ enrollment.program.display_name }}
                        <span class="date float-right font-italic text-muted">{{ dateRangeFormat(enrollment.starts_at, enrollment.ends_at) }}</span>
                    </h4>
                </div>
            </div>

            <div v-if="pastEnrollments.length > 0">
                <h2>{{ $t('courses.title_past') }}</h2>
                <div class="card p-3 mb-3 course-listing" v-for="enrollment in pastEnrollments" :key="enrollment.id">
                    <h4 class="m-0 float-left">{{ enrollment.program.display_name }}
                        <span class="date float-right font-italic text-muted">{{ dateRangeFormat(enrollment.starts_at, enrollment.ends_at) }}</span>
                    </h4>
                </div>
            </div>


         

                <!-- <div class="card-body bg-white border">

                    <div class="card-header bg-transparent p-0 mb-3">
                        <h1><i class="fa fa-folder-open-o"></i>  {{ $t('courses.shared_files_header') }}
                            <div class="btn-group float-right">
                                <button type="button" class="btn btn-light btn-icon px-3" @click="newFile()" v-b-tooltip title="Add Shared File"> 
                                    <i class="fa fa-plus fa-lg"></i>
                                </button>
                            </div>
                        </h1>
                    </div>

                    <div> -->
                        <!-- <table v-if="files.length > 0" class="table table-striped table-hover"> -->
                            <!-- <table  class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>File</th>
                                    <th>Size</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="file in files" :key="file.id">
                                    <td><a :href="file.url" target="_blank">{{ file.filename }}</a></td>
                                    <td>{{ file.filesize }}</td>
                                </tr>
                            </tbody>
                        </table> -->

                        <!-- <div v-if="files.length == 0">No Files Found.</div> -->

                    <!-- </div>

                
                    <b-modal id="modalFile" ref="modalFile" title="Add Shared File" size="xs" centered @ok="addFile()">
                    <div class="uniform-uploader border w-100">
                        <input type="file" name="file" accept="image/*,.pdf,.xlsx,.docx,.mp3,.mp4" @change="fileChange($event.target.files)" /> -->
                        <!-- <span class="filename border-0 pl-1" style="user-select: none;" v-html="(clientFile.name) ? clientFile.name : 'Drop File here'"></span> -->
                        <!-- <span class="action btn btn-secondary" style="user-select: none;">Choose File</span> -->
                    <!-- </div>
                    </b-modal>

                </div> -->
                    
                
        </div>       

    </div>

                
            

</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers'

import moment from 'moment'
import i18n from '@/i18n';

export default {
    name: 'TherapyListing',
    data() {
        return {
            // clientFile: {},
            //allowedFileTypes: ['image/jpeg', 'image/png', 'image/gif', 'text/plain', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'video/mp4', 'audio/mpeg']
		}
    },
    watch: {
        '$i18n.locale': function (newVal, oldVal) {
            // Fetch PreScreens if lang is changed.
            this.fetchPreScreens();
        }
    },

    created () {
        // this.fetchSharedFiles();
    },
    mounted () {
        this.fetchPreScreens();
    },
    methods: {
        ...mapActions(['fetchPreScreens', 'preScreenEnroll', 'enrollmentWithdraw', 'fetchEnrollments', 'enrollmentView', 'fetchSharedFiles', 'addSharedFile']),
        ...mapNotificationEventActions,
        dateRangeFormat (start, end) {
            return moment(String(start)).format('MMMM D')+" -to- "+moment(String(end)).format('MMMM D, YYYY');
        },
        displayEnrollmentHandler(id) {
           this.enrollmentView(id).catch(errHandler);
        },
        enrollPreScreen (program_id) {
            this.preScreenEnroll(program_id).then((id) => {
                if (id) {
                    this.emitSuccess({msg: this.$t('courses.prescreen_success') });
                    this.fetchEnrollments().then((v) => {
                        this.enrollmentView(id).catch(errHandler);
                        this.$router.push({ name: 'therapy.display', params: { enrol_id: id } });
                    });
                } else this.emitError({msg: this.$t('courses.prescreen_error') });
            });
        },
        btnWithdraw ( e_id ) {
            this.$swal({
				title: this.$t('courses.withdraw_title'),
				text: this.$t('courses.withdraw_text'),
				type: 'warning',
				showCancelButton: true,
                cancelButtonText: this.$t('courses.withdraw_cancel_button'),
                confirmButtonText: this.$t('courses.withdraw_ok_button'),
                confirmButtonColor: '#C82232'
			}).then((result) => {
                if (result.value == true) {
                    this.$swal({
						text: this.$t('courses.withdraw_confirm'),
						type: 'question',
                        input: 'text',
                        showCancelButton: true,
                        cancelButtonText: this.$t('courses.withdraw_cancel_button'),
                        confirmButtonText: this.$t('courses.withdraw_ok_button'),
                        confirmButtonColor: '#C82232'
					}).then((q) => {
                        if(q.dismiss != 'cancel') {
                            if (q.value) {
                                this.enrollmentWithdraw({enrol_id: e_id, note: q.value}).then((v) => {
                                    this.$swal({title: this.$t('courses.withdraw_success_title'), text: this.$t('courses.withdraw_success'), type: 'success',confirmButtonText: this.$t('courses.withdraw_ok_button')});
                                });
                            } else this.$swal({title: this.$t('courses.withdraw_error_title'), text:        this.$t('courses.withdraw_error'), type: 'error',confirmButtonText: this.$t('courses.withdraw_ok_button')});
                        }
                    });
                }
			});
        }
        // newFile () {
        //     this.$refs.modalFile.show();
		// },
        //  addFile () {
        //     let formData = new FormData();
        //     // Check for Allowed File Types
        //     if (!this.allowedFileTypes.includes(this.clientFile.type)) {
        //         this.emitError({msg: 'File Type ('+this.clientFile.type+') NOT Allowed.'});
        //         this.clientFile = {};
        //         return;
        //     }
        //   	formData.append('file', this.clientFile, this.clientFile.name);
		// 	this.addSharedFile(formData).then((v) => {
		// 		this.emitSuccess({msg: 'Shared File Added'});
		// 		this.clientFile = {};
		// 	}).catch(errHandler);
        // },
        // fileChange (files) {
        //     this.clientFile = files[0];
        // }
    },
    computed: {
        enrollments () {
            return (this.$store.state.programs.enrollments) ? this.$store.state.programs.enrollments : {};
        },
        activeEnrollments () {
            let enrollments = this.enrollments;
            let keys = Object.keys(enrollments);
            let active = [];
            keys.forEach( function ( enrolId ) {
                if ( enrollments[enrolId].terminated_at == null && moment().isAfter(moment(enrollments[enrolId].starts_at)) && moment().isBefore(moment(enrollments[enrolId].ends_at)) )
                    active.push(enrollments[enrolId]);
            });
            return active;
        },
        pastEnrollments () {
            let enrollments = this.enrollments;
            let keys = Object.keys(enrollments);
            let past = [];
            keys.forEach( function ( enrolId ) {
                if ( moment().isAfter(moment(enrollments[enrolId].ends_at)) || moment().isAfter(moment(enrollments[enrolId].terminated_at)) ) past.push(enrollments[enrolId]);
            });
            return past;
        },
        futureEnrollments () {
            let enrollments = this.enrollments;
            let keys = Object.keys(enrollments);
            let future = [];
            keys.forEach( function ( enrolId ) {
                if ( enrollments[enrolId].terminated_at == null && moment().isBefore(moment(enrollments[enrolId].starts_at)) ) future.push(enrollments[enrolId]);
            });
            return future;
        },
        noEnrollments () {
            return (this.activeEnrollments.length == 0 && this.futureEnrollments.length == 0) ? true : false;
        },
        preScreens () {
            return (this.$store.state.programs.prescreens) ? _.filter(this.$store.state.programs.prescreens, function(ps) { return ps.state == 'published' }) : {};
        }
        // files () {
        //     let files = this.$store.state.users.shared_files;
        //     return _.orderBy(files, 'filename', 'desc');
        // }
    }
}
</script>
